import produce from "immer"
import {
    NO, NONE, ACTIVE, ASC, VALUE, PUBLIC,
} from "const"
import { MtPackage } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initPackageSettings: types.PackageSettings = {
    // drive
    driveSpace: 0,
    driveSpaceValue: 0,
    cloudDrivesAllowed: NO,

    // okr
    okrModuleAccess: NO,

    // rrs
    rrsRiskSpaceModuleAccess: NO,
    rrsRiskSpaceTemplates: NONE,
    rrsRiskSpaceTemplatesValue: 0,

    // study
    studyModuleAccess: NO,

    // tasks
    taskModuleAccess: NO,
    subTaskModuleAccess: NO,
    taskGrantView: NO,
    taskKanbanView: NO,

    // project
    projectModuleAccess: NO,
    projects: 1,
    projectsValue: 0,
    subProjects: NONE,
    subProjectsValue: 0,
    projectTeamMembers: 1,
    projectTeamMembersValue: 0,

    // cc
    ccModuleAccess: NO,
    ccAccountComplianceSets: NONE,
    ccAccountComplianceSetsValue: 0,
    ccLibraryComplianceSets: NONE,
    ccLibraryComplianceSetsValue: 0,
    ccCompliantItems: NONE,
    ccCompliantItemsValue: 0,
    ccProjectCompliantItems: NONE,
    ccProjectCompliantItemsValue: 0,
    ccResponseModuleAccess: NO,
    ccApprovalModuleAccess: NO,
    ccRequirementsModuleAccess: NO,
    ccRequirements: VALUE,
    ccRequirementsValue: 0,

    // lifecycle
    lifecycleModuleAccess: NO,
    lifecycles: NONE,
    lifecyclesValue: 0,
    subLifecycles: NONE,
    subLifecyclesValue: 0,

    // sil
    silModuleAccess: NO,
    silAccountDevices: NONE,
    silAccountDevicesValue: 0,
    silAccountSubsystems: NONE,
    silAccountSubsystemsValue: 0,
    silSafetyFunctions: NONE,
    silSafetyFunctionsValue: 0,
    silCalculations: NONE,
    silCalculationsValue: 0,
    silReports: NONE,
    silReportsValue: 0,

    // qid
    qidModuleAccess: NO,

    // markov
    markovModuleAccess: NO,
}

export const initPackage: MtPackage = {
    id: null,
    name: "",
    settings: null,
    maxUsers: 0,
    price: 0,
    status: ACTIVE,
    visibility: PUBLIC,
}

const initPackageState: types.PackageState = {
    packageList: {},
    packageIds: [],
    packageEdit: initPackage,
    packageSettings: initPackageSettings,

    packageAllowed: {},
    activeCell: null,

    sortColumn: "createdAt",
    sortOrder: ASC,
    filters: {
        status: null,
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const packageReducer = produce((
    draft: types.PackageState = initPackageState,
    action: ActionTypes = null,
): types.PackageState => {
    switch (action.type) {
        case types.PACKAGE_LIST:
            draft.packageList = action.packageList
            return draft

        case types.PACKAGE_IDS:
            draft.packageIds = action.packageIds
            return draft

        case types.PACKAGE_EDIT:
            draft.packageEdit = action.package
            return draft

        case types.PACKAGE_ACTIVE_CELL:
            draft.activeCell = action.activeCell
            return draft

        case types.PACKAGE_ALLOWED:
            draft.packageAllowed = {
                ...draft.packageAllowed,
                ...action.packageAllowed,
            }
            return draft

        case types.PACKAGE_SETTINGS:
            draft.packageSettings = { ...draft.packageSettings, ...action.settings }
            return draft

        case types.PACKAGE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.PACKAGE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.PACKAGE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.PACKAGE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default packageReducer
